import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import { Creators as MessagesCreators } from "../ducks/messages";
import { Creators as SessionCreators } from "../ducks/session";
import { Creators as UserCreators } from "../ducks/user";
import api from "../../services/api";

export function* invalidate() {
  yield put(UserCreators.clearSession());
  yield call(api.delete, "sessions");
  window.localStorage.removeItem("authToken");
  yield put(push("/"));
}

export function* authenticate({ payload }) {
  const response = yield call(api.post, "/v2/customers/sessions", {
    customer: { ...payload }
  });

  yield put(MessagesCreators.clearMessages());

  if (response.ok) {
    yield put(SessionCreators.saveSession(response.data.token));

    let path = "/";
    if (payload.toSubscription) path = "/credit-card";

    if (payload.queryString.has("redirect")) {
      const redirect = payload.queryString.get("redirect");
      path = `/${redirect}`;
    }

    window.location.href = path;
  } else {
    window.localStorage.removeItem("authToken");
    yield put(SessionCreators.authFailure());

    if (response.status === 401) {
      yield put(
        MessagesCreators.setMessage("Usuário ou senha inválidos", "warning")
      );
    } else {
      yield put(
        MessagesCreators.setMessage(
          "Erro inesperado, tente novamente.",
          "danger"
        )
      );
    }
  }
}

export function* authBytoken({ payload }) {
  const response = yield call(
    api.post,
    `/v2/customers/sessions/auth/${payload.token}`
  );

  if (response.ok) {
    yield put(SessionCreators.saveSession(response.data.token));
    // yield put(push('/credit-card'));
    yield put(push("/"));
  } else {
    window.localStorage.removeItem("authToken");
    yield put(SessionCreators.authFailure());
  }
}

export function* saveSession({ payload }) {
  window.localStorage.setItem("authToken", payload.token);
  yield put(UserCreators.refrashUser());
  yield put(SessionCreators.authSuccess());
}



// WEBPACK FOOTER //
// ./src/store/sagas/session.js